// extracted by css-extract-rspack-plugin
export default {"Container":"rPEFA","headVariant":"Zd4RW","HeaderBadge":"JuLAn","HeaderBreadcrumbs":"EtYGG","HeaderBadgeIcon":"euRni"};